/* eslint-disable */
import IMask from 'imask';
import { IMaskDirective } from 'vue-imask';
import { toRaw } from 'vue';

const maskTypesForModification = ['Date', 'Number', 'IMask.MaskedRange', 'IMask.MaskedEnum'];

export function useImask(app) {
    app.directive('imask', {
        name: 'imask',
        beforeMount: (el, binding) => modifyBindings(el, binding, IMaskDirective.beforeMount),
        updated: (el, binding) => modifyBindings(el, binding, IMaskDirective.updated),
        unmounted: (el, binding) => modifyBindings(el, binding, IMaskDirective.unmounted),
    });
}

function tryToModify(mask) {
    if (maskTypesForModification.includes(mask) || mask.match(/^\/.+\/$/)) {
        return {
            result: eval(mask),
            isModified: true,
        };
    }

    return {
        result: mask,
        isModified: false,
    };
}

function getFilter(name) {
    switch (name) {
        case 'uppercase':
            return (string) => {
                return string.toUpperCase();
            };

        case 'lowercase':
            return (string) => {
                return string.toLowerCase();
            };

        case 'slug':
            return (string) => {
                string = string.replace(/^\s+|\s+$/g, '');
                string = string.toLowerCase();
                string = string
                    .replace(/[^a-z0-9 -]/g, '') // remove any non-alphanumeric characters
                    .replace(/\s+/g, '-') // replace spaces with hyphens
                    .replace(/-+/g, '-');

                return string;
            };
    }
}

function modifyBindings(el, binding, imaskFn) {
    if (binding.value) {
        const { modified, parsed } = prepareBindings(binding);

        if (modified) {
            imaskFn(el, { value: parsed });
        } else {
            imaskFn(el, binding);
        }
    }
}

function prepareBindings(binding) {
    let modified = false;
    const stringified = JSON.stringify(binding.value);
    const parsed = JSON.parse(stringified, (key, value) => {
        if (typeof value === 'object' && typeof value.mask !== 'undefined') {
            const { result, isModified } = tryToModify(value.mask);
            value.mask = result;

            if (isModified && !modified) {
                modified = true;
            }
        }

        return value;
    });

    if (binding.value.filter) {
        modified = true;
        const filter = getFilter(binding.value.filter);
        parsed.prepareChar = filter;
    }

    return {
        modified,
        parsed,
    };
}

export function getMasked(mask, value) {
    const { parsed } = prepareBindings({ value: mask });

    const masked = IMask.createMask(parsed);
    masked.resolve(value);

    return masked.value;
}
